import type { LanguageCode } from "@/app/core/language.model";

export type LocalizedTextMap =
  | Partial<Record<LanguageCode, string>>
  | null
  | undefined;

export const CONTENT_LANGUAGES: { code: LanguageCode; label: string }[] = [
  { code: "en", label: "English" },
  { code: "pt", label: "Portuguese" },
  { code: "nl", label: "Dutch" },
  { code: "sv", label: "Swedish" },
];

export const TRANSLATION_LANGUAGES = CONTENT_LANGUAGES.filter(
  (language) => language.code !== "en",
);

export function normalizeLocalizedTextMap(
  value: unknown,
): Partial<Record<LanguageCode, string>> {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};

  return CONTENT_LANGUAGES.reduce<Partial<Record<LanguageCode, string>>>(
    (result, language) => {
      const text = (value as Record<string, unknown>)[language.code];
      if (typeof text === "string") {
        result[language.code] = text;
      }
      return result;
    },
    {},
  );
}

export function resolveLocalizedText(
  fallback: string | null | undefined,
  translations: LocalizedTextMap,
  language: LanguageCode,
) {
  const normalized = normalizeLocalizedTextMap(translations);
  const localizedText = normalized[language]?.trim();
  const englishText = normalized.en?.trim();
  const fallbackText = fallback?.trim();

  return localizedText || englishText || fallbackText || "";
}

export function setLocalizedText(
  translations: LocalizedTextMap,
  language: LanguageCode,
  value: string,
) {
  return {
    ...normalizeLocalizedTextMap(translations),
    [language]: value,
  };
}
